import styles from './register-style.css';
import { RegistrationForm } from './components/RegistrationForm.js';
import { DelayShowForms } from './components/DelayShowForms.js';
import { decodeHtml } from '../functions/decodeHtml/decodeHtml.js';
const { render } = wp.element;

/*The top level registration form component
props:
	nonceName: 	(string) the nonce name
	nonce: 		(string) the nonce
	reset:		(string) the html form, as a string, for reseting a password
	loggedin:	(string) if the users is logged in
	loginform:	(string) the html form, as a string, for loging in
	logout:		(string) the html form, as a string, for loging out
*/
function Register (props) {
	let { 
			loggedin:loggedIn, 
			loginform:loginForm, 
			logout:logOut, 
			reset, 
			nonce, 
			noncename:nonceName 
		} = props,
		content,
		resetForm = <div dangerouslySetInnerHTML={{__html:decodeHtml(reset) }}/>;

	if ( loggedIn ) {
		return <div>
			<p> You are already logged in.</p>
			<div dangerouslySetInnerHTML={{__html:decodeHtml(logOut) }}/>
			{resetForm}
		</div>;
	}
	if ( !loggedIn ) {
		content = <div dangerouslySetInnerHTML={{__html:decodeHtml(loginForm) }}/>;
	}

	return <>
		<DelayShowForms buttonText="Click to Login" form={content}/>  
		<div className={styles.spacer}></div>
		<DelayShowForms buttonText="Click to Register" form={<RegistrationForm nonce={nonce} nonceName={nonceName} /> }/> 
		{resetForm}
	</>;
}

window.addEventListener('DOMContentLoaded', () => {
	//get the for settings and then hydrate it
	let el = document.getElementsByClassName('login-registration-form-advanced'),
		asArray = Object.values(el); //convert the resulting object to an array for easier working.
		
	asArray.forEach((e)=>{
		let props =  e.dataset; //get the props passed via the dataset
		ReactDOM.hydrate( <Register {...props} />, e);
	});
});